
import { PaymentSummary } from '@/components/counting/types/PaymentTypes';

export const useSummaryCalculations = () => {
  const calculateSummaries = async (data: any): Promise<PaymentSummary[]> => {
    if (!data) return [];

    const summariesMap = new Map<string, PaymentSummary>();

    // Fonction pour extraire la méthode de paiement des notes
    const getPaymentMethodFromNotes = (notes: string): string => {
      const notesLower = notes?.toLowerCase() || '';
      if (notesLower.includes('cash') || notesLower.includes('espèces')) {
        return 'Espèces';
      } else if (notesLower.includes('wave')) {
        return 'Wave';
      } else if (notesLower.includes('orange money')) {
        return 'Orange Money';
      } else if (notesLower.includes('bank_transfer') || notesLower.includes('virement')) {
        return 'Virement bancaire';
      }
      return 'Espèces'; // Méthode par défaut
    };

    // Initialiser les méthodes de paiement standard avec des montants à zéro
    ['Espèces', 'Virement bancaire', 'Wave', 'Orange Money'].forEach(method => {
      summariesMap.set(method, {
        method,
        amount: 0,
        transactions: [],
      });
    });

    // Traiter les ventes
    if (data.sales) {
      data.sales.forEach((sale: any) => {
        if (!sale.validation_status || sale.validation_status === 'pending') {
          const paymentMethod = sale.payment_method || getPaymentMethodFromNotes(sale.notes);
          const summary = summariesMap.get(paymentMethod);
          
          if (summary) {
            summary.amount += (sale.amount || 0);
            summary.transactions.push({
              id: sale.id,
              amount: sale.amount,
              type: sale.transaction_type,
              notes: sale.notes || '',
            });
          }
        }
      });
    }

    // Traiter les retours
    if (data.returns) {
      data.returns.forEach((returnTx: any) => {
        if (!returnTx.validation_status || returnTx.validation_status === 'pending') {
          const paymentMethod = returnTx.payment_method || getPaymentMethodFromNotes(returnTx.notes) || 'Espèces';
          const summary = summariesMap.get(paymentMethod);
          
          if (summary) {
            summary.amount -= (returnTx.amount || 0);
            summary.transactions.push({
              id: returnTx.id,
              amount: -returnTx.amount,
              type: 'return',
              notes: returnTx.notes || 'Retour',
            });
          }
        }
      });
    }

    return Array.from(summariesMap.values());
  };

  return { calculateSummaries };
};
